'use client';

import React, { useState, useEffect } from 'react';
import LoadingSpinner from '@/components/LoadingSpinner';

interface LoadingWrapperProps {
  children: React.ReactNode;
  loadingDuration?: number; // in milliseconds
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({ children, loadingDuration = 500 }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, loadingDuration);

    return () => clearTimeout(timer);
  }, [loadingDuration]);

  if (isLoading) {
    return <LoadingSpinner isLoading={true} />;
  } else {
    return <>{children}</>;
  }
};

export default LoadingWrapper;
